import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';



export function getReferenciaBancariaListSuccess(referenciabancaria) {
  return {type: types.LOAD_REFERENCIABANCARIA_LIST_SUCCESS, referenciabancaria};
}



export function getReferenciaBancariaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ReferenciaBancariaApi.getReferenciaBancariaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(referenciabancaria => {                  
                  dispatch(getReferenciaBancariaListSuccess(referenciabancaria));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getReferenciaBancariaSuccess(catalogo) {
  return {type: types.LOAD_REFERENCIABANCARIA_SUCCESS, catalogo};
}

export function getReferenciaBancaria(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().ReferenciaBancariaApi.getReferenciaBancaria(id, token).then(referenciabancaria => {   
        dispatch(getReferenciaBancariaSuccess(referenciabancaria));
        return referenciabancaria;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(referenciabancaria) {
  return {type: types.SAVE_REFERENCIABANCARIA_SUCCESS, referenciabancaria};
}


export function save(referenciabancaria, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().ReferenciaBancariaApi.save(referenciabancaria, token).then(referenciabancariaGuardado => {   
    dispatch(saveSuccess(referenciabancariaGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getReferenciaBancariaComboSuccess(datos) {
  return {type: types.GET_REFERENCIABANCARIAS_COMBO_SUCCESS, datos};
}

export function getReferenciaBancariaCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().ReferenciaBancariaApi.getReferenciaBancariaCombo(token).then(datos => {   
        
      dispatch(getReferenciaBancariaComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(referenciabancaria) {
  return {type: types.BORRAR_REFERENCIABANCARIA_SUCCESS, referenciabancaria};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ReferenciaBancariaApi.borrar(id, token ).then(referenciabancaria => {
               
                  dispatch(borrarSuccess(referenciabancaria));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(referenciabancaria) {
  return {type: types.ACTIVAR_REFERENCIABANCARIA_SUCCESS, referenciabancaria};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ReferenciaBancariaApi.activar(id, token).then(referenciabancaria => {
               
                  dispatch(activarSuccess(referenciabancaria));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_REFERENCIABANCARIA, filtro};
}



